import { extend } from 'umi-request'
// import routerData from '../router/index'
import { router } from '../router/index'
import { Message } from 'element-ui'
import { message } from '@/utils/resetMessage'
import store from '@/store'

import NProgress from 'nprogress'

import envUtils from '@/utils/envUtils'
let baseUrl = envUtils('VUE_APP_BASE_URL')
const isStandalone = envUtils('VUE_APP_STANDALONE')

const codeMessage = {
  400: '400:发出的请求有错误，服务器没有进行新建或修改数据的操作。',
  // 401: '用户没有权限（令牌、用户名、密码错误）。',
  403: '403:用户得到授权，但是访问是被禁止的。',
  404: '404:发出的请求针对的是不存在的记录，服务器没有进行操作。',
  405: '405:方法不被允许',
  406: '406:请求的格式不可得。',
  410: '410:请求的资源被永久删除，且不会再得到的。',
  422: '422:当创建一个对象时，发生一个验证错误。',
  500: '500:服务器发生错误，请检查服务器。',
  502: '502:网关错误。',
  503: '503:服务不可用，服务器暂时过载或维护。',
  504: '当前服务器繁忙，请稍后再试'
}

/**
 * 异常处理程序
 * 请求已发送但服务端返回状态码非 2xx 的响应
 */
const errorHandler = async (error) => {
  const { response = {}, data = {} } = error
  let code = 9999
  let errortext = ''
  if (response && (response.status || response.statusText)) {
    errortext = codeMessage[response.status] || response.statusText
  }
  if (response && response.status === 400) {
    try {
      message.error(data.errors[0].defaultMessage)
    } catch (err) {
      message.error('400:发出的请求有错误，服务器没有进行新建或修改数据的操作。')
    }
  } else if (response && response.status === 401) {
    try {
      code = data.code
    } catch (err) {
    }
    if (code === 1000) {
      errortext = isStandalone === 'true' ? '账户名或密码错误' : '租户id、账户名或密码错误'
      message.error(errortext)
      // localStorage.clear()
      router.push('/login')
    } else if (code === 1001) {
      const lastTime = store.state.user.last1001Time
      if ((new Date()).valueOf() - lastTime > 500 || lastTime === 0) {
        message.error('登录已失效，请重新登录')
      }
      store.commit('user/setLast1001Time', { time: (new Date()).valueOf() }) // 时间戳精确到毫秒
      // localStorage.clear()
      router.push('/login')
    } else if (code === 1002) {
      Message.error('登录已过期，请重新登录')
      // localStorage.clear()
      router.push('/login')
    } else if (code === 1003) {
      message.error('账户已被冻结')
      // localStorage.clear()
      router.push('/login')
    } else if (code === 1004) {
      message.error('账号已在别处登录')
      // localStorage.clear()
      router.push('/login')
    } else if (code === 1006) {
      message.error('账号对应角色权限发生变动，请重新登录')
      // localStorage.clear()
      router.push('/login')
    } else {
      message.error('用户没有权限')
    }
    // } else if (response.status === 404) {
    //   router.push('/404')
  } else {
    if (errortext) {
      Message.error(errortext)
    }
  }
  return Promise.reject(error)
}

/**
 * 配置request请求时的默认参数
 */
const request = extend({
  errorHandler // 默认错误处理
})
// let loadServe
request.interceptors.request.use((url, options) => {
  const noNPUrl = ['getAllQueue', 'getTimeModels', 'extraTime']
  let flag = true
  noNPUrl.some(u => {
    if (url.indexOf(u) !== -1) {
      flag = false
      return true
    }
  })
  if (flag) {
    NProgress.start()
  }
  const cToken = localStorage.getItem('Authorization')

  // 为每一个请求添加时间戳，防止浏览器缓存
  options.params = {
    ...options.params,
    _t: Date.parse(new Date())
  }

  // 网关地址不能以/结尾
  while (baseUrl.endsWith('/')) {
    baseUrl = baseUrl.substring(0, baseUrl.length - 1)
    console.log('网关地址不能以"/"号结尾！')
  }

  let headers
  if (cToken) {
    if (url.indexOf('printscreen') !== -1) {
      headers = {
        // 'Content-Type': 'multipart/form-data',
        Accept: '*/*',
        'Access-Control-Allow-Origin': '*',
        'Access-Control-Allow-Credentials': true,
        'X-REFRESH-TOKEN': false,
        Authorization: cToken,
        ...options.headers
      }
    } else {
      headers = {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        'Access-Control-Allow-Origin': '*',
        'Access-Control-Allow-Credentials': true,
        'X-REFRESH-TOKEN': false,
        Authorization: cToken,
        ...options.headers
      }
    }
    if (isStandalone === 'false') {
      headers['X-TENANT-ID'] = localStorage.getItem('X-TENANT-ID')
    }
    return (
      {
        url: `${baseUrl}${url}`,
        options: { ...options, headers: headers, getResponse: true }
      }
    )
  } else {
    return (
      {
        url: `${baseUrl}${url}`,
        options: { ...options, getResponse: true }
      }
    )
  }
})

// response拦截器, 处理response
// 前端获取自定义的header需要在服务器端定义 Access-Control-Expose-Headers
request.interceptors.response.use(async (response) => {
  const token = response.headers.get('Authorization')
  const expiresAt = response.headers.get('CURRENT_TOKEN_EXPIRESAT')
  if (token) {
    localStorage.setItem('Authorization', token)
  }
  if (expiresAt) {
    localStorage.setItem('expiresAt', expiresAt)
  }
  NProgress.done()
  return response
})

export default request
